/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-19 21:54:17
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-22 00:06:24
 * @FilePath: /mooctest.com/src/utils/loading.js
 */

import { Loading } from "element-ui";
import _ from "lodash";
import { t } from "../i18n/i18n";

let loading = null;
let requestCount = 0;

const startLoading = (container = {}) => {
  loading = Loading.service({
    lock: true,
    text: container?.text || t("common.loading"),
    fullscreen: true,
    target: container?.target || "body",
  });
};

const endLoading = _.debounce(
  () => {
    if (loading) {
      loading.close();
      loading = null;
    }
  },
  3000,
  { leading: true, trailing: true },
);

export const showScreenLoading = (container) => {
  if (requestCount === 0 && !loading) {
    startLoading(container);
  }
  requestCount++;
};

export const hideScreenLoading = () => {
  if (requestCount <= 0) return;
  requestCount--;
  requestCount = Math.max(requestCount, 0);
  if (requestCount === 0) {
    endLoading();
  }
};
